'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _Array$from = require('@babel/runtime-corejs3/core-js-stable/array/from');
var _Symbol = require('@babel/runtime-corejs3/core-js-stable/symbol');
var _getIteratorMethod = require('@babel/runtime-corejs3/core-js/get-iterator-method');
var _Array$isArray = require('@babel/runtime-corejs3/core-js-stable/array/is-array');
var _typeof = require('@babel/runtime-corejs3/helpers/typeof');
var _slicedToArray = require('@babel/runtime-corejs3/helpers/slicedToArray');
var _toConsumableArray = require('@babel/runtime-corejs3/helpers/toConsumableArray');
var _JSON$stringify = require('@babel/runtime-corejs3/core-js-stable/json/stringify');
var _URLSearchParams = require('@babel/runtime-corejs3/core-js-stable/url-search-params');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _Object$keys = require('@babel/runtime-corejs3/core-js-stable/object/keys');
var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var _sliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/slice');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _lastIndexOfInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/last-index-of');
var _endsWithInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/ends-with');
var _parseInt = require('@babel/runtime-corejs3/core-js-stable/parse-int');
var _filterInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/filter');
var _Number$isNaN = require('@babel/runtime-corejs3/core-js-stable/number/is-nan');
var _Map = require('@babel/runtime-corejs3/core-js-stable/map');
var _Object$entries = require('@babel/runtime-corejs3/core-js-stable/object/entries');
var _Set = require('@babel/runtime-corejs3/core-js-stable/set');
var lodash = require('lodash');
var papaparse = require('papaparse');
var index = require('../bigint/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _Array$from__default = /*#__PURE__*/_interopDefaultLegacy(_Array$from);
var _Symbol__default = /*#__PURE__*/_interopDefaultLegacy(_Symbol);
var _getIteratorMethod__default = /*#__PURE__*/_interopDefaultLegacy(_getIteratorMethod);
var _Array$isArray__default = /*#__PURE__*/_interopDefaultLegacy(_Array$isArray);
var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _JSON$stringify__default = /*#__PURE__*/_interopDefaultLegacy(_JSON$stringify);
var _URLSearchParams__default = /*#__PURE__*/_interopDefaultLegacy(_URLSearchParams);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _Object$keys__default = /*#__PURE__*/_interopDefaultLegacy(_Object$keys);
var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);
var _sliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sliceInstanceProperty);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _lastIndexOfInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_lastIndexOfInstanceProperty);
var _endsWithInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_endsWithInstanceProperty);
var _parseInt__default = /*#__PURE__*/_interopDefaultLegacy(_parseInt);
var _filterInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_filterInstanceProperty);
var _Number$isNaN__default = /*#__PURE__*/_interopDefaultLegacy(_Number$isNaN);
var _Map__default = /*#__PURE__*/_interopDefaultLegacy(_Map);
var _Object$entries__default = /*#__PURE__*/_interopDefaultLegacy(_Object$entries);
var _Set__default = /*#__PURE__*/_interopDefaultLegacy(_Set);

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof _Symbol__default["default"] && _getIteratorMethod__default["default"](r) || r["@@iterator"]; if (!t) { if (_Array$isArray__default["default"](r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { var _context16; if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = _sliceInstanceProperty__default["default"](_context16 = {}.toString.call(r)).call(_context16, 8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from__default["default"](r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

/**
 * Graph chart infos to save.
 * - latestGraph: current result in graph chart.
 * - latestSelections: current selections in graph chart.
 * - latestLayout: current graph chart layout.
 *
 * @export
 * @interface ChartData
 */

var NumberFormatSettings = /*#__PURE__*/function (NumberFormatSettings) {
  NumberFormatSettings["ThousandsSeparator"] = "thousandsSeparator";
  NumberFormatSettings["UnifyDecimalSpaces"] = "unifyDecimalSpaces";
  NumberFormatSettings["DecimalSeparator"] = "decimalSeparator";
  return NumberFormatSettings;
}({});
exports.HelperFunctions = void 0;
(function (_HelperFunctions) {
  var defaultNumberFormatting = _HelperFunctions.defaultNumberFormatting = {
    thousandsSeparator: {
      enabled: false,
      value: ','
    },
    unifyDecimalSpaces: {
      enabled: false,
      value: '0'
    },
    decimalSeparator: {
      enabled: true,
      value: '.'
    }
  };
  var dataFileName = _HelperFunctions.dataFileName = 'MyDataSource';
  function applyGraphNameToURL(graphName, url) {
    return url.replace('[GRAPH_NAME]', graphName);
  }
  _HelperFunctions.applyGraphNameToURL = applyGraphNameToURL;
  function replacePlaceholderInUrl(url, replaceObject) {
    var _context;
    var result = url;
    _forEachInstanceProperty__default["default"](_context = _Object$keys__default["default"](replaceObject)).call(_context, function (placeholder) {
      if (_includesInstanceProperty__default["default"](result).call(result, "".concat(placeholder))) {
        result = result.replace("".concat(placeholder), replaceObject[placeholder]);
      } else {
        var _context2;
        console.error(_concatInstanceProperty__default["default"](_context2 = "'".concat(placeholder, "' doesn't exist in '")).call(_context2, url, "'"));
      }
    });
    return result;
  }
  _HelperFunctions.replacePlaceholderInUrl = replacePlaceholderInUrl;
  function capitalizeFirstCharacter(word) {
    if (!word) {
      return '';
    }
    return word.charAt(0).toUpperCase() + _sliceInstanceProperty__default["default"](word).call(word, 1);
  }
  _HelperFunctions.capitalizeFirstCharacter = capitalizeFirstCharacter;
  function convertIdxToOrdinalStr(indexes) {
    var _context3;
    if (!indexes) {
      return [];
    }
    var ordinalStrs = _mapInstanceProperty__default["default"](_context3 = _mapInstanceProperty__default["default"](indexes).call(indexes, function (i) {
      return i + 1;
    })).call(_context3, function (o) {
      switch (o) {
        case 1:
          return '1st';
        case 2:
          return '2nd';
        case 3:
          return '3rd';
        default:
          return "".concat(o, "th");
      }
    });
    return ordinalStrs;
  }
  _HelperFunctions.convertIdxToOrdinalStr = convertIdxToOrdinalStr;
  function escapeHtml(str) {
    if (!str) {
      return '';
    }
    return str.replace(/[&<>"']/g, function (m) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        '\'': '&#039;'
      }[m];
    });
  }
  _HelperFunctions.escapeHtml = escapeHtml;
  function escapeQuote(str) {
    if (!str) {
      return '';
    }
    return str.replace(/[\\"']/g, function (m) {
      return {
        '\\': '\\\\',
        '"': '\\"',
        '\'': '\\\''
      }[m];
    });
  }
  _HelperFunctions.escapeQuote = escapeQuote;
  function fileNameToId(fileName) {
    return fileName.replace(/[^a-zA-Z0-9]/g, '_');
  }
  _HelperFunctions.fileNameToId = fileNameToId;
  function idGenerator() {
    return Math.random().toString(36).substr(2);
  }
  _HelperFunctions.idGenerator = idGenerator;
  function joinStrAsPara(strs) {
    var len = strs.length;
    var arr = _sliceInstanceProperty__default["default"](strs).call(strs);
    var str = _sliceInstanceProperty__default["default"](arr).call(arr, 0, len - 1).join(', ');
    if (len > 1) {
      str += " and ".concat(arr[len - 1]);
    } else {
      str = arr[0];
    }
    return str || '';
  }
  _HelperFunctions.joinStrAsPara = joinStrAsPara;
  function removeConcatCharsAndToLowerCase(fileName) {
    return fileName.replace(/[ _/\-\t\r]/g, '').toLowerCase();
  }
  _HelperFunctions.removeConcatCharsAndToLowerCase = removeConcatCharsAndToLowerCase;
  function retrieveFileNameFromPath(path) {
    return _lastIndexOfInstanceProperty__default["default"](path).call(path, '/') > -1 ? path.substring(_lastIndexOfInstanceProperty__default["default"](path).call(path, '/') + 1) : path;
  }
  _HelperFunctions.retrieveFileNameFromPath = retrieveFileNameFromPath;
  function truncateUTF8String(value, maxWidth) {
    var len = 0;
    var cutEllipsis = -1;
    var cutLength = -1;
    for (var i = 0; i < value.length; i++) {
      if (value.charCodeAt(i) >= 0 && value.charCodeAt(i) < 256) {
        len++;
      } else {
        len += 2;
      }
      if (len > maxWidth - 3 && cutEllipsis === -1) {
        cutEllipsis = i;
      }
      if (len > maxWidth) {
        cutLength = i - 1;
        break;
      }
    }
    if (cutLength > -1) {
      return value.substring(0, cutEllipsis) + '...';
    } else {
      return value;
    }
  }
  _HelperFunctions.truncateUTF8String = truncateUTF8String;
  function strLenUTF8(value) {
    var len = 0;
    for (var i = 0; i < value.length; i++) {
      if (value.charCodeAt(i) >= 0 && value.charCodeAt(i) < 256) {
        len++;
      } else {
        len += 2;
      }
    }
    return len;
  }
  _HelperFunctions.strLenUTF8 = strLenUTF8;
  function strWidthUTF8(value, fontSize) {
    var narrow = 0;
    for (var i = 0; i < value.length; i++) {
      if ('…' === "".concat(value[i])) {
        narrow++;
      }
    }
    return (exports.HelperFunctions.strLenUTF8(value) + value.length * 0.26) * fontSize / 2.26 - narrow * 0.44 * fontSize;
  }
  _HelperFunctions.strWidthUTF8 = strWidthUTF8;
  function twoPointsNearEachOther(x1, y1, x2, y2, dist) {
    return Math.abs(x1 - x2) < dist && Math.abs(y1 - y2) < dist;
  }
  _HelperFunctions.twoPointsNearEachOther = twoPointsNearEachOther;
  function retrieveAttributeAndAccumValue(attrs, name) {
    var attrValue = attrs[name];
    // If the attribute is printed as vSet.attrName, it should also be applied.
    if (attrValue === undefined) {
      var _context4;
      _forEachInstanceProperty__default["default"](_context4 = _Object$keys__default["default"](attrs)).call(_context4, function (attrName) {
        if (_endsWithInstanceProperty__default["default"](attrName).call(attrName, ".".concat(name))) {
          attrValue = attrs[attrName];
        }
      });
    }
    return attrValue;
  }
  _HelperFunctions.retrieveAttributeAndAccumValue = retrieveAttributeAndAccumValue;
  function changeColorOpacity(colorHex, opacity) {
    var _context5, _context6, _context7;
    if (colorHex.length !== 7) {
      return undefined;
    }
    var red = _parseInt__default["default"](colorHex.substring(1, 3), 16);
    var green = _parseInt__default["default"](colorHex.substring(3, 5), 16);
    var blue = _parseInt__default["default"](colorHex.substring(5, 7), 16);
    return _concatInstanceProperty__default["default"](_context5 = _concatInstanceProperty__default["default"](_context6 = _concatInstanceProperty__default["default"](_context7 = "rgba(".concat(red, ", ")).call(_context7, green, ", ")).call(_context6, blue, ", ")).call(_context5, opacity, ")");
  }
  _HelperFunctions.changeColorOpacity = changeColorOpacity;
  function exclude(leftSet, rightSet) {
    return _filterInstanceProperty__default["default"](leftSet).call(leftSet, function (lhs) {
      return _filterInstanceProperty__default["default"](rightSet).call(rightSet, function (rhs) {
        return lodash.isEqual(lhs, rhs);
      }).length === 0;
    });
  }
  _HelperFunctions.exclude = exclude;
  function epochToDatetime(epoch, timeZone) {
    var _context8;
    var tzOffset = timeZone !== undefined ? timeZone : new Date().getTimezoneOffset() * 60000;
    var date = new Date(epoch - tzOffset);
    return _sliceInstanceProperty__default["default"](_context8 = date.toISOString().replace('T', ' ')).call(_context8, 0, -5);
  }
  _HelperFunctions.epochToDatetime = epochToDatetime;
  function beautifySeconds(sec) {
    if (sec < 1) {
      return "".concat(sec, "s");
    }
    var result = '';
    var remain = Math.round(sec);
    // seconds
    result = "".concat(remain % 60, "s") + result;
    // minutes
    remain = Math.floor(remain / 60);
    if (remain > 0) {
      result = "".concat(remain % 60, "m ") + result;
    }
    // hours
    remain = Math.floor(remain / 60);
    if (remain > 0) {
      result = "".concat(remain % 24, "h ") + result;
    }
    // days
    remain = Math.floor(remain / 24);
    if (remain > 0) {
      result = "".concat(remain, "d ") + result;
    }
    return result;
  }
  _HelperFunctions.beautifySeconds = beautifySeconds;
  function abbreviateByte(bytes) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (bytes === null || bytes === undefined || _Number$isNaN__default["default"](bytes)) {
      return 'NaN';
    }
    if (bytes === 0) {
      return '0Bytes';
    }
    var suffix = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var k = 1024;
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    decimals = bytes > k ? decimals : 0; // prevent small number to have fraction.

    return (bytes / Math.pow(k, i)).toFixed(decimals) + suffix[i];
  }
  _HelperFunctions.abbreviateByte = abbreviateByte;
  function abbreviateNumber(number) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (number === null || number === undefined || _Number$isNaN__default["default"](number)) {
      return 'NaN';
    }
    if (number === 0) {
      return '0';
    }
    var suffix = ['', 'K', 'M', 'B', 'T', 'KT', 'MT', 'BT', 'TT'];
    var k = 1000;
    var i = Math.floor(Math.log(number) / Math.log(k));
    decimals = number > k ? decimals : 0; // prevent small number to have fraction.

    return (number / Math.pow(k, i)).toFixed(decimals) + suffix[i];
  }
  _HelperFunctions.abbreviateNumber = abbreviateNumber;
  function beautifyNumber(num) {
    if (num === 0) {
      return '0';
    }
    var result = '';
    var sig = num < 0 ? '-' : '';
    num = Math.abs(num);
    for (var cnt = 0; num > 0;) {
      result = num % 10 + result;
      num = Math.floor(num / 10);
      if (++cnt % 3 === 0 && num > 0) {
        result = ',' + result;
      }
    }
    return sig + result;
  }
  _HelperFunctions.beautifyNumber = beautifyNumber;
  function convertMapToObject(map) {
    if (!map) {
      return;
    }
    var obj = {};
    for (var _i = 0, _arr = _toConsumableArray__default["default"](map); _i < _arr.length; _i++) {
      var _arr$_i = _slicedToArray__default["default"](_arr[_i], 2),
        key = _arr$_i[0],
        value = _arr$_i[1];
      obj[key] = value;
    }
    return obj;
  }
  _HelperFunctions.convertMapToObject = convertMapToObject;
  function convertObjectToMap(obj) {
    var _context9;
    if (!obj) {
      return;
    }
    var map = new _Map__default["default"]();
    _forEachInstanceProperty__default["default"](_context9 = _Object$entries__default["default"](obj)).call(_context9, function (_ref) {
      var _ref2 = _slicedToArray__default["default"](_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      map.set(key, value);
    });
    return map;
  }
  _HelperFunctions.convertObjectToMap = convertObjectToMap;
  function replaceAlias(exprString, oldAlias, newAlias) {
    return exprString ? exprString.replace(new RegExp("(\\W|^)(".concat(oldAlias, "\\.)"), 'g'), function (_, p1) {
      return p1 + (newAlias ? "".concat(newAlias, ".") : '');
    }) : exprString;
  }
  _HelperFunctions.replaceAlias = replaceAlias;
  function hasVertexOrEdgeType(udt) {
    for (var i = 0; i < udt.fields.length; i++) {
      var type = udt.fields[i].fieldType;
      if (type === 'VERTEX' || type === 'EDGE') {
        return true;
      }
    }
    return false;
  }
  _HelperFunctions.hasVertexOrEdgeType = hasVertexOrEdgeType;
  function hasVarLengthString(udt) {
    var _iterator = _createForOfIteratorHelper(udt.fields),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var field = _step.value;
        if (field.fieldType === 'STRING' && field.length === undefined) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return false;
  }
  _HelperFunctions.hasVarLengthString = hasVarLengthString;
  function toggleCheckStatus(elements, typesToChange) {
    var isVertex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (isVertex) {
      var _context10;
      var unselectedVertices = _mapInstanceProperty__default["default"](_context10 = _filterInstanceProperty__default["default"](elements).call(elements, function (element) {
        return !element.selected;
      })).call(_context10, function (element) {
        return element.vertexOrEdgeType.Name;
      });
      _forEachInstanceProperty__default["default"](typesToChange).call(typesToChange, function (vertexType) {
        var edge = vertexType.vertexOrEdgeType;
        if (_includesInstanceProperty__default["default"](unselectedVertices).call(unselectedVertices, edge.FromVertexTypeName) || _includesInstanceProperty__default["default"](unselectedVertices).call(unselectedVertices, edge.ToVertexTypeName)) {
          vertexType.selected = false;
        } else if (edge.EdgePairs) {
          var _iterator2 = _createForOfIteratorHelper(edge.EdgePairs),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var edgePair = _step2.value;
              if (_includesInstanceProperty__default["default"](unselectedVertices).call(unselectedVertices, edgePair.From) || _includesInstanceProperty__default["default"](unselectedVertices).call(unselectedVertices, edgePair.To)) {
                vertexType.selected = false;
                break;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      });
    } else {
      var _context11;
      var verticesToSelect = new _Set__default["default"]();
      _forEachInstanceProperty__default["default"](_context11 = _filterInstanceProperty__default["default"](elements).call(elements, function (element) {
        return element.selected;
      })).call(_context11, function (element) {
        var edge = element.vertexOrEdgeType;
        verticesToSelect.add(edge.FromVertexTypeName);
        verticesToSelect.add(edge.ToVertexTypeName);
        var edgePairs = edge.EdgePairs;
        if (edgePairs) {
          _forEachInstanceProperty__default["default"](edgePairs).call(edgePairs, function (edgePair) {
            verticesToSelect.add(edgePair.From);
            verticesToSelect.add(edgePair.To);
          });
        }
      });
      _forEachInstanceProperty__default["default"](typesToChange).call(typesToChange, function (type) {
        if (verticesToSelect.has(type.vertexOrEdgeType.Name)) {
          type.selected = true;
        }
      });
    }
  }
  _HelperFunctions.toggleCheckStatus = toggleCheckStatus;
  function limitStringDisplayLength(str, start, end) {
    var _context12;
    return str.replace(new RegExp(_concatInstanceProperty__default["default"](_context12 = "(.{".concat(start, "})..+(.{")).call(_context12, end, "})"), 'g'), '$1...$2');
  }
  _HelperFunctions.limitStringDisplayLength = limitStringDisplayLength;
  function convertRowsToCSVBlob(header, rows) {
    var csv = papaparse.unparse(rows, {
      header: true,
      columns: header
    });
    var blob = new Blob([csv], {
      type: 'text/plain;charset=utf-8'
    });
    return blob;
  }
  _HelperFunctions.convertRowsToCSVBlob = convertRowsToCSVBlob;
  function isPrimitive(value) {
    var valueType = _typeof__default["default"](value);
    return valueType === 'number' || valueType === 'string' || valueType === 'boolean';
  }
  _HelperFunctions.isPrimitive = isPrimitive;
  function isObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
  }
  _HelperFunctions.isObject = isObject;
  function numberFormatting(number, unifyDecimalSpaces, thousandsSeparator, decimalSeparator) {
    var res;

    // Unify decimal spaces
    if (unifyDecimalSpaces.enabled) {
      res = number.toFixed(Number(unifyDecimalSpaces.value));
    } else {
      res = String(number);
    }

    // Decimal separator
    res = res.replace('.', decimalSeparator.value);

    // Thousands separator
    if (thousandsSeparator.enabled) {
      var _res$split = res.split(decimalSeparator.value),
        _res$split2 = _slicedToArray__default["default"](_res$split, 2),
        intPart = _res$split2[0],
        decimalPart = _res$split2[1];
      res = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator.value);
      if (decimalPart) {
        var _context13, _context14;
        res = _concatInstanceProperty__default["default"](_context13 = _concatInstanceProperty__default["default"](_context14 = "".concat(res)).call(_context14, decimalSeparator.value)).call(_context13, decimalPart);
      }
    }
    return res;
  }
  _HelperFunctions.numberFormatting = numberFormatting;
  function numberFormattingForAttrs(attrValue, settings) {
    var numberFormattingData = defaultNumberFormatting;
    if (settings && settings.numberFormatting) {
      numberFormattingData = settings.numberFormatting;
    }
    var _numberFormattingData = numberFormattingData,
      thousandsSeparator = _numberFormattingData.thousandsSeparator,
      unifyDecimalSpaces = _numberFormattingData.unifyDecimalSpaces,
      decimalSeparator = _numberFormattingData.decimalSeparator;
    return numberFormatting(attrValue, unifyDecimalSpaces, thousandsSeparator, decimalSeparator);
  }
  _HelperFunctions.numberFormattingForAttrs = numberFormattingForAttrs;
  function insertGraphNameForInterpretMode(gsqlQuery, graphName) {
    var Status = /*#__PURE__*/function (Status) {
      Status[Status["START"] = 0] = "START";
      Status[Status["IN_PARAMETER"] = 1] = "IN_PARAMETER";
      Status[Status["IN_STRING"] = 2] = "IN_STRING";
      Status[Status["IN_STRING_SKIP"] = 3] = "IN_STRING_SKIP";
      Status[Status["STOP"] = 4] = "STOP";
      return Status;
    }({});
    var parenthesisNestingLevel = 0;
    var curState = Status.START;
    for (var index = 0; index < gsqlQuery.length; index++) {
      var curChar = gsqlQuery.charAt(index);
      switch (curState) {
        case Status.START:
          // before encounter any (
          if (curChar === '(') {
            curState = Status.IN_PARAMETER;
            parenthesisNestingLevel += 1;
          }
          break;
        case Status.IN_PARAMETER:
          // after encounter the ( inside the parameter
          if (curChar === '(') {
            parenthesisNestingLevel += 1;
          } else if (curChar === '"') {
            curState = Status.IN_STRING;
          } else if (curChar === ')') {
            parenthesisNestingLevel -= 1;
            if (parenthesisNestingLevel === 0) {
              curState = Status.STOP;
            }
          }
          break;
        case Status.IN_STRING:
          // encounter the "
          if (curChar === '\\') {
            // if there's a \ skip the character after it
            curState = Status.IN_STRING_SKIP;
          } else if (curChar === '"') {
            // if there's another "
            curState = Status.IN_PARAMETER;
          }
          break;
        case Status.IN_STRING_SKIP:
          // encounter the \ inside ", skip this character
          curState = Status.IN_STRING;
          break;
      }
      if (curState === Status.STOP) {
        // arrive at the position of the right bracket of parameter
        var findGraphName = new RegExp(/^\)\s*for\s+graph/i);
        if (gsqlQuery.substring(index, gsqlQuery.length).match(findGraphName)) {
          // Right after the parameter, there's a FOR GRAPH keyword following
          break;
        }
        return gsqlQuery.substring(0, index + 1) + " FOR GRAPH ".concat(graphName, " ") + gsqlQuery.substring(index + 1, gsqlQuery.length);
      }
    }
    return gsqlQuery;
  }
  _HelperFunctions.insertGraphNameForInterpretMode = insertGraphNameForInterpretMode;
  function concatURLAndSearchParams(url, init) {
    var _context15;
    var params = new _URLSearchParams__default["default"](init);
    return _concatInstanceProperty__default["default"](_context15 = "".concat(url, "?")).call(_context15, params);
  }
  _HelperFunctions.concatURLAndSearchParams = concatURLAndSearchParams;
})(exports.HelperFunctions || (exports.HelperFunctions = {}));
/**
 * Use state machine to get to the end of parameter part and insert graph name.
 *
 * @export
 * @param {string} gsqlQuery
 * @param {string} graphName
 * @return {*}  {string}
 */
function insertGraphNameForInterpretMode(gsqlQuery, graphName) {
  var Status = /*#__PURE__*/function (Status) {
    Status[Status["START"] = 0] = "START";
    Status[Status["IN_PARAMETER"] = 1] = "IN_PARAMETER";
    Status[Status["IN_STRING"] = 2] = "IN_STRING";
    Status[Status["IN_STRING_SKIP"] = 3] = "IN_STRING_SKIP";
    Status[Status["STOP"] = 4] = "STOP";
    return Status;
  }({});
  var parenthesisNestingLevel = 0;
  var curState = Status.START;
  for (var index = 0; index < gsqlQuery.length; index++) {
    var curChar = gsqlQuery.charAt(index);
    switch (curState) {
      case Status.START:
        // before encounter any (
        if (curChar === '(') {
          curState = Status.IN_PARAMETER;
          parenthesisNestingLevel += 1;
        }
        break;
      case Status.IN_PARAMETER:
        // after encounter the ( inside the parameter
        if (curChar === '(') {
          parenthesisNestingLevel += 1;
        } else if (curChar === '"') {
          curState = Status.IN_STRING;
        } else if (curChar === ')') {
          parenthesisNestingLevel -= 1;
          if (parenthesisNestingLevel === 0) {
            curState = Status.STOP;
          }
        }
        break;
      case Status.IN_STRING:
        // encounter the "
        if (curChar === '\\') {
          // if there's a \ skip the character after it
          curState = Status.IN_STRING_SKIP;
        } else if (curChar === '"') {
          // if there's another "
          curState = Status.IN_PARAMETER;
        }
        break;
      case Status.IN_STRING_SKIP:
        // encounter the \ inside ", skip this character
        curState = Status.IN_STRING;
        break;
    }
    if (curState === Status.STOP) {
      // arrive at the position of the right bracket of parameter
      var findGraphName = new RegExp(/^\)\s*for\s+graph/i);
      if (gsqlQuery.substring(index, gsqlQuery.length).match(findGraphName)) {
        // Right after the parameter, there's a FOR GRAPH keyword following
        break;
      }
      return gsqlQuery.substring(0, index + 1) + " FOR GRAPH ".concat(graphName, " ") + gsqlQuery.substring(index + 1, gsqlQuery.length);
    }
  }
  return gsqlQuery;
}

// implement toJSON function for BigInt, so that it can be stringified by native JSON.stringify
// @ts-ignore
BigInt.prototype.toJSON = function () {
  return this.toString();
};
function parseJSON(response) {
  var parsedData;
  try {
    parsedData = index({
      useNativeBigInt: true
    }).parse(response);
  } catch (e) {
    console.error(e);
    parsedData = JSON.parse(response);
  }
  return parsedData;
}
function stringifyJSON(result) {
  var str;
  try {
    str = index({
      useNativeBigInt: true
    }).stringify(result, null, 2);
  } catch (e) {
    str = _JSON$stringify__default["default"](result, null, 2);
  }
  return str;
}

// On cloud 4, the app should use this function to get param string(carrys workspace info)
// when generate the redirection URL to other app or itself
function getToolsRedirectionURLParamStr() {
  var params = new _URLSearchParams__default["default"]();
  var baseURL = sessionStorage.getItem('BASEURL') || '';
  var domain = baseURL.match(/tg-[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\.[a-zA-Z0-9.-]+?\.(privatelink|i)/i);
  if (!domain) {
    console.error('Invalid base url', baseURL);
    return '';
  }
  params.set('domain', domain[0]);
  params.set('clusterid', sessionStorage.getItem('CURRENTCLUSTERID'));
  params.set('orgName', sessionStorage.getItem('ORGNAME'));
  params.set('groupid', sessionStorage.getItem('CURRENTGROUPID'));
  params.set('cloudVersion', sessionStorage.getItem('CLOUDVERSION'));
  if (sessionStorage.getItem('CLOUDENV')) {
    params.set('cloudEnv', sessionStorage.getItem('CLOUDENV'));
  }
  return params.toString();
}

exports.NumberFormatSettings = NumberFormatSettings;
exports.getToolsRedirectionURLParamStr = getToolsRedirectionURLParamStr;
exports.insertGraphNameForInterpretMode = insertGraphNameForInterpretMode;
exports.parseJSON = parseJSON;
exports.stringifyJSON = stringifyJSON;
